// Module
var code = `talentExpertHiringFunnelOverviewComponent`;
// Exports
export default code;